// registration-wizard/CourseSelectionStep.tsx
import { Stack, Select, Textarea, Loader } from '@mantine/core';
import { CourseDateModelView } from '@actschurch/ccms-sdk';
import { dateLabelParts } from '../helpers';

export interface CourseSelectionStepProps {
  courses: any[];
  loadingCourses: boolean;
  courseID: string | null;
  onCourseIDChange: (val: string | null) => void;

  courseDates: CourseDateModelView[];
  loadingDates: boolean;
  dateID: string | null;
  onDateIDChange: (val: string | null) => void;

  description: string;
  onDescriptionChange: (val: string) => void;
}

export function CourseSelectionStep({
  courses,
  loadingCourses,
  courseID,
  onCourseIDChange,
  courseDates,
  loadingDates,
  dateID,
  onDateIDChange,
  description,
  onDescriptionChange,
}: CourseSelectionStepProps) {
  
  return (
    <Stack gap="md">
      <Select
        label="Course"
        placeholder={loadingCourses ? 'Loading courses…' : 'Select a course'}
        data={courses.map((c) => ({
          value: String(c.courseID),
          label: c.name ?? c.courseName ?? `Course ${c.courseID}`,
        }))}
        value={courseID}
        onChange={onCourseIDChange}
        searchable
        disabled={loadingCourses}
        required
      />

      <Select
        label="Intake Date"
        placeholder={
          !courseID        ? 'Select a course first'       :
          loadingDates     ? 'Loading dates…'              :
          courseDates.length === 0 ? 'No dates available' :
          'Select an intake date'
        }
        data={courseDates.map((d) => ({
          value: String(d.dateID),
          label: dateLabelParts(d),
        }))}
        value={dateID}
        onChange={onDateIDChange}
        searchable
        disabled={!courseID || loadingDates || courseDates.length === 0}
        required
        rightSection={loadingDates ? <Loader size={14} /> : undefined}
      />

      <Textarea
        label="Description"
        placeholder="Registration description"
        value={description}
        onChange={(e) => onDescriptionChange(e.currentTarget.value)}
        minRows={2}
      />
    </Stack>
  );
}

export default CourseSelectionStep;